import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Labelformate für DHL (Backend übersetzt in printFormat: labeldrucker → 910-300-600, a4 → A4)
export const LABEL_FORMATS = [
  { value: "labeldrucker", label: "Labeldrucker (103 × 199 mm)" },
  { value: "a4", label: "DIN A4" },
];
export const DEFAULT_LABEL_FORMAT = "labeldrucker";
export const labelFormatName = (v) => LABEL_FORMATS.find((f) => f.value === v)?.label || "";

// Versand-Einstellungen (Standard-Labelformat, Hinweistext Rechnung); lädt bei jedem `open`-Wechsel auf true neu.
export function useVersandSettings(open = true) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    if (!open) return;
    api.get("/versand/einstellungen").then((r) => setSettings(r.data)).catch(() => setSettings({ label_format: DEFAULT_LABEL_FORMAT }));
  }, [open]);
  return settings;
}
